import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { TDateFormat } from '../types/apia/date';
import { getWindow } from '../dom/getWindow';

dayjs.extend(customParseFormat);

declare global {
  interface Window {
    DATE_FORMAT: string;
  }
}

export const DEFAULT_DATE_FORMAT: TDateFormat = 'DD/MM/YYYY';

export const getDateFormat = (format?: string): TDateFormat => {
  switch (format ?? getWindow().DATE_FORMAT) {
    case 'm/d/Y':
      return 'MM/DD/YYYY';
    case 'd/m/Y':
      return DEFAULT_DATE_FORMAT;
    case 'Y/m/d':
      return 'YYYY/MM/DD';
    default:
      return 'DD/MM/YYYY';
  }
};
